// extracted by mini-css-extract-plugin
module.exports = {"parentEntityName":"Caption_parentEntityName__aK9uO","strikethrough":"Caption_strikethrough__2brbt"};